import useCardholderType from "./hooks/useCardholderType";

const App = () => {
  const { cardholderType } = useCardholderType();

  return cardholderType?.supplementary_cardholder ? (
    <p>Supplementary cardholder</p>
  ) : (
    <p>Main cardholder</p>
  );
};

export default App;
